/**
 * ArrowDisabler Plugin for the glide.js slider
 * Disables the right arrow when the last slide is reached
 * Disables the left arrow when the first slide is reached
 * @param {*} Glide
 * @param {*} Components
 * @param {*} Events
 */
export default function (Glide, Components, Events) {
	return {
		mount () {
			// Only in effect when rewinding is disabled
			if (Glide.settings.rewind) {
				return
			}
			Glide.on(['mount.after', 'run'], () => {
				// Filter out arrows_control
				for (let controlItem of Components.Controls.items) {
					if (controlItem.className !== 'glide__arrows') {
						continue
					}

					// Set left arrow state
					var left = controlItem.querySelector('.glide__arrow--left')
					if (left) {
						if (Glide.index === 0) {
							left.setAttribute('disabled', '') // Disable on first slide
						} else {
							left.removeAttribute('disabled') // Enable on other slides
						}
					}

					// Set right arrow state
					var right = controlItem.querySelector('.glide__arrow--right')
					if (right) {
						if (Glide.index === Components.Sizes.length - 1) {
							right.setAttribute('disabled', '') // Disable on last slide
						} else {
							right.removeAttribute('disabled') // Disable on other slides
						}
					}
				}
			})
		}
	}
}

